import React from "react"
import styled from "styled-components"
import CardBackground from "../CardBackground"
import H4 from "../../typography/H4"
import P from "../../typography/P"
import InternalButton from "../InternalButton"
import FeatureCardImageWrapper from "./FeatureCardImageWrapper"
import FeatureCardInnerImageWrapper from "./FeatureCardInnerImageWrapper"

const FeatureCard = ({ icon, title, description, link, outline }) => (
  <FeatureCardBackground>
    <img src={icon} />
    <H4>{title}</H4>
    <P>{description}</P>
    <InternalButton className="featureButton" to={link} outline={outline} />
  </FeatureCardBackground>
)

export default FeatureCard

const FeatureCardBackground = styled(CardBackground)`
  padding: 50px 25px;

  ${({ theme }) => theme.se`
      margin-bottom: 40px;
    
    padding: 30px 20px 20px 20px;
    
    img {
      height: 120px;
    }
  `}

  ${({ theme }) => theme.desktop`
    width: 23%;
    margin: 0 auto;
    padding: 50px 20px;

    :first-child, :nth-child(2) {
      margin-bottom: 0;
    }

    p {
      font-size: 18px;
    }
  `}
`
